/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { dateFormate } from "util/Util";

const ProjectDetail = ({ data }: any) => {
  const project = data;

 

  return (
    //  Here Changed Text And Font Size For Every Field
    <div className="rounded-xl overflow-hidden shadow-md bg-white dark:bg-gray-800 w-full">
      <div className="md:flex w-full">
        <div className="p-4 w-full">

          {/* Header Row: Project ID and Documents Action Icon */}
          <div className="flex justify-between items-start w-full">
            <p className="mt-4 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3 flex-1">
              <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Project Id:</span>
              <span className="text-slate-700 dark:text-slate-300 font-semibold">{project.projectId}</span>
            </p>

            
          </div>

          {/* <div className="flex space-x-3 mt-2  leading-tight font-medium text-black"> */}
          <p className="mt-3 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3">
            <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Project Name:</span>
            <span className="text-slate-900 dark:text-slate-100 font-bold text-lg">{project.name || "Unnamed Project"}</span>
          </p>
          {/* </div> */}
          <p className="mt-3 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3">
            <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Manager:</span>
            <span className="text-slate-700 dark:text-slate-300 font-semibold">{project.manager || "Not specified"}</span>
          </p>
          <p className="mt-3 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3">
            <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Team Size:</span>
            <span className="text-slate-700 dark:text-slate-300 font-semibold">{project.teamSize || "Not specified"}</span>
          </p>
          <p className="mt-3 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3">
            <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Start Date:</span>
            <span className="text-slate-700 dark:text-slate-300 font-semibold">{dateFormate(project.startDate) || "Not specified"}</span>
          </p>
          <p className="mt-3 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3">
            <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Completion Date:</span>
            <span className="text-slate-700 dark:text-slate-300 font-semibold">{dateFormate(project.completionDate) || "Not specified"}</span>
          </p>
          <p className="mt-3 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3">
            <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Client Name:</span>
            <span className="text-slate-700 dark:text-slate-300 font-semibold">{project.clientContactName || "Not specified"}</span>
          </p>
          <p className="mt-3 grid grid-cols-[180px_minmax(0,1fr)] items-baseline gap-3">
            <span className="w-full justify-self-end text-right text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500">Contact:</span>
            <span className="text-slate-700 dark:text-slate-300 font-semibold">{project.clientContactNumber || "Not specified"}</span>
          </p>

          <div className="mt-6 p-4 rounded-xl bg-slate-50 dark:bg-slate-800/50 border border-slate-100 dark:border-slate-800">
            <span className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 block mb-2">Project Detail:</span>
            <p className="text-slate-600 dark:text-slate-400 leading-relaxed italic">{project.projectDetail || "No details provided."}</p>
          </div>

          <div className="mt-6 flex flex-wrap gap-2 items-center">
            <span className="text-xs font-bold uppercase tracking-wider text-slate-400 dark:text-slate-500 mr-2">Team Members:</span>
            {project.emails &&
              project.emails.split(",").map((email: string, index: number) => (
                <span key={index} className="px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold border border-primary/20 shadow-sm">
                  {email.trim()}
                </span>
              ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;